import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async (portalModule, params) => {
  return await dponetAPI.get(
    `/company_guest_portal_configs/${portalModule}/company_guest_domains`,
    { params },
  )
}

const create = async (portalModule, data) => {
  return await dponetAPI.post(
    `/company_guest_portal_configs/${portalModule}/company_guest_domains`,
    { companyGuestDomain: data },
  )
}

const destroy = async (portalModule, companyGuestDomainId) => {
  return await dponetAPI.delete(
    `/company_guest_portal_configs/${portalModule}/company_guest_domains/${companyGuestDomainId}`,
  )
}

export default { get, create, destroy }
